export default "__VITE_ASSET__MRQo$sPf__"